import { render, staticRenderFns } from "./FasapaySuccess.vue?vue&type=template&id=f37b3f50&"
import script from "./FasapaySuccess.vue?vue&type=script&lang=js&"
export * from "./FasapaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports